<template>
  <div>
    <b-autocomplete
      :key="searchRenderKey"
      v-model="relatedOrder.orderId"
      :error-messages="getErrorMessages(v$.orderId)"
      :item-title="
        item => `${item.name} ${item.number ? `(${item.number})` : null}`
      "
      :items="searchOrderList"
      class="mb-4"
      item-value="id"
      no-filter
      placeholder="Оберіть наказ"
      @blur="v$.orderId.$touch()"
      @update:model-value="handleModelUpdate"
      @update:search="handleSearch"></b-autocomplete>
  </div>
</template>

<script lang="ts">
import { PropType, reactive, ref, Ref } from 'vue'
import { axios, required, useVuelidate } from '@/plugins/index.js'
import { urlOrderRelatedAdd } from '@/utils/urls.js'
import { debounce } from 'lodash'
import { getErrorMessages } from '@/utils/helpers.js'
import { Dialog } from '@/dialog'
import { sendRequest } from 'best-modules/vue-utils'

export default {
  name: 'RelatedOrder',
  props: {
    dialog: {
      type: Object as PropType<Dialog>,
      required: true,
    },
  },
  methods: { getErrorMessages },
  async setup(props) {
    const searchOrderList = ref<any[]>([])
    const searchRenderKey: Ref<number> = ref(1)

    const relatedOrder = reactive({
      orderId: null as any,
    })

    const selectingItem: Ref<boolean> = ref(false)

    const handleModelUpdate = (orderId: number): void => {
      selectingItem.value = true
      relatedOrder.orderId = orderId
    }

    const handleSearch = debounce((search: string) => {
      if (selectingItem.value) {
        selectingItem.value = false
        return
      }

      if (search) {
        return sendRequest({
          name: 'globalSearch',
          method: 'get',
          url: {
            url: '/json/generalSearch',
            query: {
              search,
              types: ['order'],
            },
          },
        }).then(res => {
          searchOrderList.value = res.order
        })
      }
    }, 400)

    const v$ = useVuelidate({ orderId: { required } }, relatedOrder)

    const submit = () => {
      return axios
        .post(urlOrderRelatedAdd(), {
          parentOrderId: props.dialog.dialogData.orderId,
          childrenOrderId: relatedOrder.orderId,
        })
        .then(res => {
          return res.data
        })
    }

    return {
      relatedOrder,
      v$,
      submit,
      searchOrderList,
      handleSearch,
      handleModelUpdate,
      searchRenderKey,
    }
  },
}
</script>
